(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smword-avis-defilants"] && !Shopify.designMode) return;
  try {
    
function smwInitReviewCarousels(root){
  var sections=Array.from(root.querySelectorAll('[data-smw-reviews]'));
  if(root.matches&&root.matches('[data-smw-reviews]'))sections.unshift(root);
  sections.forEach(function(section){
    if(section.dataset.smwReady==='1')return;
    var track=section.querySelector('[data-smw-track]');
    var rail=section.querySelector('.smw-avis__rail');
    var cards=rail?Array.from(rail.children):[];
    if(!track||cards.length<2)return;
    section.dataset.smwReady='1';
    var playback=section.querySelector('[data-smw-playback]');
    var positionLabel=section.querySelector('[data-smw-position]');
    var progress=section.querySelector('[data-smw-progress]');
    var dialog=section.querySelector('[data-smw-dialog]');
    var dialogContent=section.querySelector('[data-smw-dialog-content]');
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobile=window.matchMedia('(max-width: 749px)');
    var visible=false,userPaused=false,keyboardFocus=false,dragging=false;
    var position=0,step=0,cycle=0,lastFrame=0,frameId=0,resumeAt=0,activeIndex=-1,visualOffset=0;
    cards.forEach(function(card,index){
      card.dataset.smwIndex=index;
      var translation=document.createElement('p');
      translation.className='smw-avis__translation';
      translation.textContent=card.querySelector('.smw-avis__original')?section.dataset.translatedLabel:'';
      var read=document.createElement('button');
      read.type='button';
      read.className='smw-avis__read';
      read.dataset.smwRead=index;
      read.textContent=section.dataset.readLabel;
      var foot=card.querySelector('.smw-avis__card-foot');
      card.insertBefore(translation,foot);
      card.insertBefore(read,foot);
    });
    section.classList.add('smw-avis--enhanced');
    function updatePosition(){
      if(!step)return;
      var index=((Math.floor((track.scrollLeft+step*.22)/step)%cards.length)+cards.length)%cards.length;
      if(index===activeIndex)return;
      activeIndex=index;
      positionLabel.textContent=String(index+1).padStart(2,'0')+' / '+String(cards.length).padStart(2,'0');
      progress.style.transform='scaleX('+((index+1)/cards.length)+')';
    }
    function measure(){
      rail.style.removeProperty('transform');
      visualOffset=0;
      var current=step?((track.scrollLeft/step)%cards.length):0;
      rail.querySelectorAll('[data-smw-clone]').forEach(function(clone){clone.remove()});
      step=cards[1].offsetLeft-cards[0].offsetLeft;
      cycle=step*cards.length;
      if(!cycle)return;
      if(!reduce.matches){
        var copies=Math.max(1,Math.ceil(track.clientWidth/cycle));
        for(var i=0;i<copies;i++)cards.forEach(function(card){
          var clone=card.cloneNode(true);
          clone.dataset.smwClone='';
          clone.setAttribute('aria-hidden','true');
          clone.querySelectorAll('a,button,summary,[tabindex]').forEach(function(el){el.setAttribute('tabindex','-1')});
          clone.querySelectorAll('[id]').forEach(function(el){el.removeAttribute('id')});
          rail.appendChild(clone);
        });
      }
      position=Math.max(0,current*step);
      track.scrollLeft=position;
      activeIndex=-1;
      playback.hidden=reduce.matches;
      updatePosition();
    }
    function go(delta){
      if(!step)return;
      rail.style.removeProperty('transform');
      visualOffset=0;
      resumeAt=performance.now()+5000;
      var current=track.scrollLeft;
      if(!reduce.matches&&current+delta*step<0){current+=cycle;track.scrollLeft=current}
      var target=Math.round(current/step)*step+delta*step;
      if(reduce.matches)target=Math.max(0,Math.min(track.scrollWidth-track.clientWidth,target));
      track.scrollTo({left:target,behavior:reduce.matches?'auto':'smooth'});
    }
    function start(){if(!frameId&&visible&&!document.hidden)frameId=requestAnimationFrame(frame)}
    function frame(now){
      frameId=0;
      if(!section.isConnected){if(observer)observer.disconnect();if(resize)resize.disconnect();return}
      if(!visible||document.hidden){lastFrame=0;return}
      var elapsed=lastFrame?Math.min(now-lastFrame,40):0;
      lastFrame=now;
      if(cycle&&!userPaused&&!keyboardFocus&&!dragging&&!dialog.open&&!reduce.matches&&now>resumeAt){
        position=(position+elapsed*(mobile.matches ? .025 : .032))%cycle;
        // Native scroll offsets are rounded; preserve the fractional movement visually.
        var whole=Math.floor(position);
        visualOffset=whole-position;
        track.scrollLeft=whole;
        rail.style.transform='translateX('+visualOffset+'px)';
      }else{position=track.scrollLeft-visualOffset}
      start();
    }
    section.querySelector('[data-smw-prev]').addEventListener('click',function(){go(-1)});
    section.querySelector('[data-smw-next]').addEventListener('click',function(){go(1)});
    playback.addEventListener('click',function(){
      userPaused=!userPaused;
      playback.setAttribute('aria-pressed',String(userPaused));
      playback.setAttribute('aria-label',userPaused?section.dataset.playLabel:section.dataset.pauseLabel);
      playback.querySelector('[data-smw-pause-icon]').toggleAttribute('hidden',userPaused);
      playback.querySelector('[data-smw-play-icon]').toggleAttribute('hidden',!userPaused);
      lastFrame=0;
      start();
    });
    track.addEventListener('scroll',updatePosition,{passive:true});
    track.addEventListener('focusin',function(event){keyboardFocus=event.target.matches(':focus-visible')});
    track.addEventListener('focusout',function(event){if(!track.contains(event.relatedTarget))keyboardFocus=false});
    track.addEventListener('pointerdown',function(event){if(event.pointerType!=='mouse'){dragging=true;resumeAt=Infinity}});
    function release(){if(dragging){dragging=false;resumeAt=performance.now()+5000}}
    track.addEventListener('pointerup',release);
    track.addEventListener('pointercancel',release);
    track.addEventListener('wheel',function(event){if(Math.abs(event.deltaX)>Math.abs(event.deltaY))resumeAt=performance.now()+5000},{passive:true});
    track.addEventListener('keydown',function(event){
      if(event.target!==track)return;
      if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(event.key==='ArrowRight'?1:-1)}
    });
    track.addEventListener('click',function(event){
      var button=event.target.closest('[data-smw-read]');
      if(!button)return;
      var card=cards[Number(button.dataset.smwRead)].cloneNode(true);
      card.className='smw-avis__dialog-card';
      card.removeAttribute('data-smw-index');
      card.querySelectorAll('.smw-avis__read,.smw-avis__translation').forEach(function(el){el.remove()});
      dialogContent.replaceChildren(card);
      dialog.showModal();
      document.documentElement.classList.add('smw-review-dialog-open');
    });
    section.querySelector('[data-smw-close]').addEventListener('click',function(){dialog.close()});
    dialog.addEventListener('click',function(event){
      if(event.target!==dialog)return;
      var box=dialog.getBoundingClientRect();
      if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();
    });
    dialog.addEventListener('close',function(){document.documentElement.classList.remove('smw-review-dialog-open');resumeAt=performance.now()+2000});
    var observer='IntersectionObserver' in window?new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;lastFrame=0;start()},{threshold:.04}):null;
    if(observer)observer.observe(track);else{visible=true;start()}
    var resize='ResizeObserver' in window?new ResizeObserver(measure):null;
    if(resize)resize.observe(track);else window.addEventListener('resize',measure);
    reduce.addEventListener('change',measure);
    document.addEventListener('visibilitychange',function(){lastFrame=0;start()});
    measure();
  });
}
smwInitReviewCarousels(document);
document.addEventListener('shopify:section:load',function(event){smwInitReviewCarousels(event.target)});


  } catch(e) { console.error(e); }
})();
})();
